import * as React from 'react';

// Microsoft 365 tile — the four-square Microsoft mark on a light tile.
// Brand-neutral placeholder; swap for licensed brand art when marketing supplies it.
const SvgComponent = (props) => (
	<svg width='98' height='99' viewBox='0 0 98 99' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<rect width='98' height='99' rx='9' fill='#FFFFFF' />
		<rect x='27' y='28' width='19' height='19' fill='#F25022' />
		<rect x='52' y='28' width='19' height='19' fill='#7FBA00' />
		<rect x='27' y='52' width='19' height='19' fill='#00A4EF' />
		<rect x='52' y='52' width='19' height='19' fill='#FFB900' />
		<text
			x='49'
			y='88'
			fill='#5E5E5E'
			fontFamily='Arial, Helvetica, sans-serif'
			fontSize='9'
			fontWeight='bold'
			textAnchor='middle'
		>
			Microsoft 365
		</text>
	</svg>
);

export default SvgComponent;
